import { render, staticRenderFns } from "./LabeledItem.vue?vue&type=template&id=2a33fedd&functional=true&"
import script from "./LabeledItem.vue?vue&type=script&lang=ts&"
export * from "./LabeledItem.vue?vue&type=script&lang=ts&"
import style0 from "./LabeledItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports